import { Avatar, Tooltip } from 'antd';
import defaultAvatarImg from '@/assets/images/web/default_avatar.png';
import s from './style.module.scss';
import { inject, observer } from 'mobx-react';
import withRouter from '@/components/withRouter';
import roleImg from '@/assets/images/simulation/role_icon.png';
import backImg from '@/assets/images/simulation/back_icon.png';
import reStartImg from '@/assets/images/simulation/restart.png';
import { Display } from '@/components/Display/Display';
import RoleIntroduceModal from '../Modal/RoleIntroduceModal';
import BackModal from '../Modal/BackModal';

import backArrowImg from '@/assets/images/backArrow.png';
import { LeftOutlined } from '@ant-design/icons';
const SimulationHeader = (props) => {
    let { navigate, params } = props;
    let { agentId } = params;
    let {
        store: { simulation, grtAi }
    } = props;
    let { headerIcon, closeGuideModal, caseInfo } = simulation;
    //角色弹窗
    const showGuideModal = () => {
        //引导弹窗打开时点击的--保存到浏览器
        if (simulation.guideModalName) {
            simulation.handleRoleStorage(true);
        }
        simulation.setGuideModalShow({
            role: true
        });
    };
    //背景弹窗
    const showBackModal = () => {
        if (simulation.guideModalName) {
            simulation.handleBackStorage(true);
        }
        simulation.setGuideModalShow({
            back: true
        });
    };
    //重新开始弹窗
    const showRestartModal = () => {
        simulation.setGuideModalShow({
            role: false,
            back: false,
            restart: true
        });
    };
    //返回聊天
    const returnChat = () => {
        navigate(`/mobile/o/${agentId}/chat`, { replace: true });
    };
    return (
        <>
            <BackModal show={simulation.guideModalShow.back} onClose={closeGuideModal}></BackModal>
            <RoleIntroduceModal show={simulation.guideModalShow.role} onClose={closeGuideModal}></RoleIntroduceModal>

            <div className={s['header-box']} style={{ position: simulation.guideModalName ? 'static' : 'sticky' }}>
                <div className={s['left']}>
                    <div onClick={returnChat} className={s['back-btn']}>
                        <img src={backArrowImg} alt="" />
                    </div>
                    <div className={s['header-content']}>
                        <div className={s['header-title']}>{caseInfo?.scene_name}</div>
                        <div className={s['ai-tip']}>内容由AI生成</div>
                    </div>
                </div>
                <div className={s['right']}>
                    <Display show={simulation.guideModalName}>
                        <>
                            <div className={s['mask']}></div>
                            <div data-type={simulation.guideModalName} className={`${s['pulse-point']} pulse-point`}></div>
                            <div data-type={simulation.guideModalName} className={s['line-box']} style={{ borderWidth: '1px' }}>
                                <div className={s['line-arrow']}>
                                    <LeftOutlined />
                                </div>
                                <div className={s['line-text']} data-type={simulation.guideModalName}>
                                    {simulation.guideModalName === 'back' ? '点击可查看事件背景' : '点击可查看角色规则介绍'}
                                </div>
                            </div>
                        </>
                    </Display>
                    <Display show={headerIcon.reStart}>
                        <div onClick={showRestartModal} className={s['header-icon']}>
                            <img src={reStartImg} alt="" />
                        </div>
                    </Display>
                    <Display show={headerIcon.role}>
                        <div onClick={showGuideModal} data-guide={simulation.guideModalName === 'role'} className={s['header-icon']}>
                            <img src={roleImg} alt="" />
                        </div>
                    </Display>
                    <Display show={headerIcon.back}>
                        <div onClick={showBackModal} data-guide={simulation.guideModalName === 'back'} className={`${s['header-icon']}`}>
                            <img src={backImg} alt="" />
                        </div>
                    </Display>

                    <Avatar className={s['avatar']} src={grtAi?.userInfo?.avatar || defaultAvatarImg}></Avatar>
                </div>
            </div>
        </>
    );
};

export default withRouter(inject('store')(observer(SimulationHeader)));
